import { EditOutlined, Restore } from "@mui/icons-material";
import ReactJson from "react-json-view";
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Link,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { RemoveRedEye } from "@mui/icons-material";
import { debounce } from "lodash";
import MUIDataTable from "mui-datatables";
import { useEffect, useMemo, useState } from "react";
import { getAllBrand } from "../../apis/Brand";
import { getAllPlayoffs } from "../../apis/Playoff";
import { getAllProduct } from "../../apis/Product";
import { getAllSeller } from "../../apis/Seller";
import { FilterAutocomplete } from "../Form/FilterAutocomplete";
import { getAllCategoryWithProductExist } from "../../apis/ProductCategory";
import { NewEditProductDrawer } from "../../pages/UniverisalCart/components/Products/NewEditProductDrawer";

export default function DataTable({ rows }) {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState({});
  const [sortingValues, setSortingValues] = useState("-created_at");
  const [count, setCount] = useState(0);
  const [rowsCount, setRowsCount] = useState(10);
  const [product, setProduct] = useState({});
  const [editOpen, setEditOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reset, setReset] = useState(false);

  const [openAttributesModal, setOpenAttributesModal] = useState(false);
  const [selectedAttributes, setSelectedAttributes] = useState(null);

  useEffect(() => {
    setLoading(true);
    getAllProduct(rowsCount, page + 1, filters, sortingValues)
      .then((res) => {
        setData(res.results);
        setCount(res.count);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [page, rowsCount, filters, sortingValues, rows]);

  const columns = [
    {
      name: "id",
      label: "Id",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ sx: { textAlign: "right" } }),
        // customBodyRender: (value, tableMeta, updateValue) => {
        // 	// console.log("yes", tableMeta);
        // 	return tableMeta.rowIndex + 1;
        // },
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Link target="_blank" href={data[tableMeta.rowIndex].url}>
              {value}
            </Link>
          );
        },
      },
    },
    {
      name: "product_category",
      label: "Category",
      options: {
        filter: false,
        // sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          // console.log("yes", value);
          return <Typography variant="p">{value.title}</Typography>;
        },
      },
    },
    {
      name: "brand",
      label: "Brand",
      options: {
        filter: false,
        // sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          // console.log("yes", value);
          return <Typography variant="p">{value.name}</Typography>;
        },
      },
    },
    {
      name: "seller",
      label: "Seller",
      options: {
        filter: false,
        // sort: true,
        display: "true",
        filterType: "custom",
        customBodyRender: (value, tableMeta, updateValue) => {
          // console.log("yes", value);
          return <Typography variant="p">{value.name}</Typography>;
        },
      },
    },
    {
      name: "original_price",
      label: "Price",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          // console.log("yes", value);
          const row = data[tableMeta.rowIndex];

          return (
            <>
              {row.discount_price !== value && (
                <Typography
                  sx={{
                    px: 1,
                    color: "#d32f2f",
                    textDecorationLine: "line-through",
                    fontWeight: "bold",
                  }}
                  variant="overline"
                  display="inline"
                >
                  {value}
                </Typography>
              )}
              <Typography
                sx={{
                  fontWeight: "bold",
                }}
                display="inline"
              >
                {row.discount_price !== value ? row.discount_price : value}
              </Typography>
            </>
          );
        },
      },
    },
    {
      name: "image",
      label: "Preview",
      options: {
        filter: false,
        // sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          // console.log("yes", value);

          return (
            <Avatar
              alt="List Logo"
              variant="square"
              sx={{
                width: 50,
                height: 67,
                objectFit: "fill",

                margin: 5,
                borderRadius: 1,
              }}
              src={value?.file}
            />
          );
        },
      },
    },
    // {
    //   name: "gallery",
    //   label: "Gallery",
    //   options: {
    //     filter: false,
    //     // sort: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       // console.log("yes", value);
    //       return (
    //         <AvatarGroup spacing="medium">
    //           {value.map((item, i) => (
    //             <Avatar
    //               key={"gallery-" + i}
    //               alt="List Logo"
    //               // variant="square"
    //               sx={{
    //                 // width: 50,
    //                 // height: 67,
    //                 objectFit: "fill",

    //                 // margin: 5,
    //                 // borderRadius: 1,
    //               }}
    //               src={item?.file}
    //             />
    //           ))}
    //         </AvatarGroup>
    //       );
    //     },
    //   },
    // },

    {
      name: "out_of_stock",
      label: "Out of Stock",
      options: {
        filter: false,
        // sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Switch
              checked={value}
              onChange={(event) => {
                event.preventDefault();
              }}
              inputProps={{
                "aria-label": "controlled",
              }}
            />
          );
        },
      },
    },

    {
      name: "attributes",
      label: "Product Attributes",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => {
          if (!value) {return "";}

          return (
            <Tooltip title="View Attributes">
              <IconButton
                color="primary"
                size="small"
                onClick={() => {
                  setSelectedAttributes(value);
                  setOpenAttributesModal(true);
                }}
              >
                <RemoveRedEye />
              </IconButton>
            </Tooltip>
          );
        },
      },
    },
    {
      name: "playoff_tags",
      label: "Playoffs/Scraped",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          if (!value?.length) {
            return <Typography variant="p">Scraped</Typography>;
          }

          return (
            <Box sx={{ pl: 2 }}>
              <Box
                sx={{
                  minWidth: 170,
                  maxHeight: 140,
                  overflowY: "auto",
                  overflowX: "hidden",
                  //   textAlign: "left",
                  //   pl: 2,
                }}
              >
                {value.map((tag, index) => (
                  <Box
                    key={tag}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      mb: 0.5,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        minWidth: 20,
                        fontWeight: 500,
                      }}
                    >
                      {index + 1}.
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        wordBreak: "break-word",
                      }}
                    >
                      {tag}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          );
        },
      },
    },

    {
      name: "tag",
      label: "Tags",
      options: {
        filter: false,
        // sort: true,

        // customBodyRender: (value, tableMeta, updateValue) => {
        // 	// console.log("yes", value);
        // 	return (
        // 		<Typography variant="p" ml={1}>
        // 			{value.name}
        // 		</Typography>
        // 	);
        // },
        customBodyRender: (value, tableMeta, updateValue) => {
          const groupedTags = value.reduce((group, tag) => {
            const { tag_type } = tag;
            group[tag_type] = group[tag_type] ?? [];
            group[tag_type].push(tag.name);
            return group;
          }, {});

          // Creating HTML content
          let htmlContent = "<div>";

          for (const [tagType, tagNames] of Object.entries(groupedTags)) {
            htmlContent += `<strong>${tagType.toUpperCase()}</strong><ul>`;
            htmlContent += tagNames
              .map((tagName) => `<li>${tagName}</li>`)
              .join("");
            htmlContent += "</ul>";
          }

          htmlContent += "</div>";

          // Returning HTML as the content of the cell
          return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;

          // return <Typography variant="p">{value.title}</Typography>;
        },
      },
    },

    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        // sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <IconButton
              color="primary"
              onClick={() => {
                setProduct(data[tableMeta.rowIndex]);
                setEditOpen(true);
              }}
            >
              <EditOutlined />
            </IconButton>
          );
        },
      },
    },
  ];

  const handleSearchChange = useMemo(
    () => debounce((searchText) => {
      setFilters((prev) => ({ ...prev, name: searchText }));
    }, 500),
    [],
  );
  const handleChange = useMemo(
    () => debounce((name, item) => {
      if (item) {
        setFilters((prev) => ({ ...prev, [name]: item?.id }));
      }
    }, 500),
    [],
  );

  useEffect(
    () => () => {
      handleSearchChange.cancel();
      handleChange.cancel();
    },
    [handleChange, handleSearchChange],
  );
  const options = {
    sortOrder: {
      name: "created_at",
      direction: "desc",
    },

    jumpToPage: true,
    selectableRows: "none",
    download: false,
    // filterType: "multiselect",
    serverSide: true,
    print: false,
    count: count,
    page: page,
    responsive: "standard",
    rowsPerPage: rowsCount,
    rowsPerPageOptions: [10, 25, 100],
    onChangePage(currentPage) {
      setPage(currentPage);
    },
    onChangeRowsPerPage(numberOfRows) {
      setPage(1);
      setRowsCount(numberOfRows);
    },
    onSearchChange: handleSearchChange,
    onColumnSortChange: (changedColumn, direction) => {
      setSortingValues(
        direction === "desc" ? `-${changedColumn}` : `${changedColumn}`,
      );
      // setPage(0)
      // setSortFields(temp);
    },
    isLoading: loading,
    textLabels: {
      body: {
        noMatch: loading ? (
          <CircularProgress />
        ) : (
          "Sorry, there is no matching data to display"
        ),
      },
    },
    onTableChange: (action, tableState) => { },
  };

  const handleReset = () => {
    setFilters({});
    setReset(true);
    setPage(0);
  };

  return (
    <Grid
      container
      spacing={2}
      py={2}
      alignItems={"center"}
      justifyContent={"flex-end"}
    >
      <Grid item xs={12} sm={3}>
        <FilterAutocomplete
          fetchOptions={getAllBrand}
          label={"Brand"}
          handleChange={handleChange}
          name={"brand"}
          reset={reset}
          setReset={setReset}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <FilterAutocomplete
          fetchOptions={getAllSeller}
          label={"Seller"}
          handleChange={handleChange}
          name={"seller"}
          reset={reset}
          setReset={setReset}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <FilterAutocomplete
          fetchOptions={getAllCategoryWithProductExist}
          label={"Category"}
          handleChange={handleChange}
          name={"category"}
          reset={reset}
          setReset={setReset}
        />
        {/* <CustomAutocomplete
					label={"Category"}
					fetchOptions={getAllCategoryWithProductExist}
				/> */}
      </Grid>
      <Grid item xs={12} sm={3}>
        <FilterAutocomplete
          fetchOptions={getAllPlayoffs}
          label={"Playoff"}
          handleChange={handleChange}
          name={"playoff"}
          reset={reset}
          setReset={setReset}
        />
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          onClick={handleReset}
          startIcon={<Restore />}
        >
          Reset
        </Button>
      </Grid>
      <Grid item xs={12}>
        <MUIDataTable
          title={"Products List"}
          data={data}
          columns={columns}
          options={options}
        />
        {/* <Drawer
					anchor="right"
					open={editOpen}
					onClose={() => setEditOpen(false)}
				>
					<AddProductDrawer
						page={page}
						rowsCount={rowsCount}
						selectedCategory={category}
						title={"Edit"}
						setEditOpen={setEditOpen}
						product={product}
						setRows={setData}
					/>
				</Drawer> */}

        <NewEditProductDrawer
          setEditOpen={setEditOpen}
          editOpen={editOpen}
          edit={true}
          product={product}
          setProducts={setData}
          fromGroup={false}
        />
      </Grid>
      <Dialog
        open={openAttributesModal}
        onClose={() => setOpenAttributesModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Product Attributes
          <IconButton
            aria-label="close"
            onClick={() => setOpenAttributesModal(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <ReactJson
            src={selectedAttributes}
            collapsed={false}
            displayDataTypes={false}
            enableClipboard={true}
            name={false}
            displayArrayKey={false}
          />
        </DialogContent>
      </Dialog>
    </Grid>
  );
}
